export function randomString(len)
{
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz";
  for( var i=0; i < len; i++ )
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
}

export var rem = (function rem() {
  var html = document.getElementsByTagName("html")[0];

  return function () {
    return parseInt(window.getComputedStyle(html).fontSize);
  };
}());

export function norm2DVect(vect) {
  return Math.sqrt(vect[0]*vect[0] + vect[1]*vect[1]);
}

export function norm3DVect(vect) {
  return Math.sqrt(vect[0]*vect[0] + vect[1]*vect[1] + vect[2]*vect[2]);
}

export function linspace(min,max,n) {
  if(typeof n === "undefined") n = Math.max(Math.round(max-min)+1,1);
  if(n<2) { return n===1?[min]:[]; }
  var i,ret = Array(n);
  n--;
  for(i=n;i>=0;i--) { ret[i] = (i*max+(n-i)*min)/n; }
  return ret;
}

export function logspaces(min,max,n,inverted=false) {
  var spaces = linspace(0,1,n).map(function(x) { return (Math.pow(10,x)-1)/9; });
  if (inverted) {
    spaces = spaces.map(function(x) { return 1-x; }).reverse();
  }
  return spaces.map(function(x) { return min + x*(max-min); });
}

export function geoCross(center,size,e=null) {
  if (e==null) {
    e = size / 4;
  }
  return {
    "type": "Polygon",
    "coordinates": [
      [
        [center[0] - size, center[1] - e],
        [center[0] - size, center[1] + e],
        [center[0] - e, center[1] + e],
        [center[0] - e, center[1] + size],
        [center[0] + e, center[1] + size],
        [center[0] + e, center[1] + e],
        [center[0] + size, center[1] + e],
        [center[0] + size, center[1] - e],
        [center[0] + e, center[1] - e],
        [center[0] + e, center[1] - size],
        [center[0] - e, center[1] - size],
        [center[0] - e, center[1] - e],
        [center[0] - size, center[1] - e],
      ]
    ]
  };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/utils.js
// module id = 0
// module chunks = 0